import { Form, Row, Col, Badge, Button, InputGroup } from 'react-bootstrap';
import icSearch from './assets/img/ic-magnifier.svg';

const CompanyFilter = ({ 
    searchQuery, setSearchQuery, 
    selectedCountry, setSelectedCountry, 
    selectedCity, setSelectedCity, 
    companies 
}) => {
    // Extract unique country and city names for dropdown
    const uniqueCountries = [...new Set(companies.map(company => company.country).filter(Boolean))].sort();
    const uniqueCities = [...new Set(
        companies
            .filter(company => !selectedCountry || company.country === selectedCountry) // ✅ filter by selected country
            .map(company => company.cityRegion)
            .filter(Boolean)
    )].sort();

    // Function to reset all filters
    const clearFilters = () => {
        setSearchQuery('');
        setSelectedCountry('');
        setSelectedCity('');
    };

    return (
        <>
            {/* Filter Inputs */}
            <div className="filter">
                <div>
                    <div className="flex-grow-1">
                        <Row>
                            {/* Search by Company Name */}
                            <Col md={4}>
                                <Form.Group controlId="searchCompany">
                                    <Form.Label>Search</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                        type="text"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <InputGroup.Text>
                                            <img src={icSearch} alt="Search" />
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="searchCountry">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Select
                                        value={selectedCountry}
                                        onChange={(e) => {
                                            setSelectedCountry(e.target.value);
                                            setSelectedCity('');
                                        }}
                                    >
                                        <option value="">Filter by country...</option>
                                        {uniqueCountries.map((country, index) => (
                                            <option key={index} value={country}>
                                                {country}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="searchCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Select
                                        value={selectedCity}
                                        onChange={(e) => setSelectedCity(e.target.value)}
                                    >
                                        <option value="">Filter by city...</option>
                                        {uniqueCities.map((city, index) => (
                                            <option key={index} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Button variant="primary" className="btn-sm">
                            Save Filters
                        </Button>
                    </div>
                </div>
                {/* Applied Filters Display */}
                {(searchQuery || selectedCountry || selectedCity) && (
                     <>
                        <Row className="filter-results">
                            <Col className="d-flex align-items-center">
                                <span>Filters:</span>
                                {searchQuery && (
                                    <Badge bg="info" className="me-2">
                                        Company: {searchQuery} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSearchQuery('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedCountry && (
                                    <Badge bg="info" className="me-2">
                                        {selectedCountry} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedCountry('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedCity && (
                                    <Badge bg="info" className="me-2">
                                        {selectedCity} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedCity('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                
                                {/* Clear All Filters Button */}
                                <Button variant="link" size="sm" className="ms-auto" onClick={clearFilters}>
                                    Clear All
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>

        </>
    );
};

export default CompanyFilter;
